import { createAction } from 'typesafe-actions';
export var genericParentIncomingEvents = {
    ready: createAction('@@FRAME_API/READY')(),
    settingsReady: createAction('@@FRAME_API/SETTINGS_READY')(),
    closeRequest: createAction('@@FRAME_API/CLOSE_REQUEST')(),
};
export var genericChildIncomingEvents = {
    settings: createAction('@@FRAME_API/SETTINGS')(),
    hidden: createAction('@@FRAME_API/HIDDEN')(),
    shown: createAction('@@FRAME_API/SHOW')(),
};
//# sourceMappingURL=GenericEvents.js.map